import React from 'react'
import { UnitSystem } from 'forms/my-account'
import styles from './HeightUnitInputs.module.scss'
import formStyles from './styles/forms.module.scss'
import { ErrorMessage, useFormikContext } from 'formik'
import { EditProfileForm } from 'types/forms/my-account'
import { getHeightFromMetric, getHeightFromImperial, initializeHeightValues } from 'utils'
import classNames from 'classnames'

interface Props {
  unitSystem: UnitSystem
}

const HeightUnitInputs = ({ unitSystem = UnitSystem.METRIC }: Props) => {
  const {
    values: { ft, inches, m, cm },
    setFieldValue,
    errors,
  } = useFormikContext<EditProfileForm>()

  return (
    <>
      {unitSystem === UnitSystem.IMPERIAL && (
        <div className={styles.heightInputs}>
          <div className={styles.inputContainer}>
            <label className={styles.label} htmlFor='heightFeet'>
              ft
            </label>
            <input
              id='heightFeet'
              type='number'
              name='ft'
              value={ft}
              min={0}
              max={7}
              onChange={e => {
                e.persist()
                setFieldValue('ft', e.target.value)
                const heightInMeters = getHeightFromImperial(Number(e.target.value), Number(inches))
                const { m, cm } = initializeHeightValues(heightInMeters)
                setFieldValue('heightInMeters', heightInMeters)
                setFieldValue('m', m)
                setFieldValue('cm', cm)
              }}
              className={classNames(styles.input, {
                [formStyles.inputError]: errors?.heightInMeters,
              })}
            />
          </div>
          <div className={styles.inputContainer}>
            <label className={styles.label} htmlFor='heightInches'>
              in
            </label>
            <input
              id='heightInches'
              type='number'
              name='inches'
              value={inches}
              min={0}
              max={11}
              onChange={e => {
                e.persist()
                setFieldValue('inches', e.target.value)
                const heightInMeters = getHeightFromImperial(Number(ft), Number(e.target.value))
                const { m, cm } = initializeHeightValues(heightInMeters)
                setFieldValue('heightInMeters', heightInMeters)
                setFieldValue('m', m)
                setFieldValue('cm', cm)
              }}
              className={classNames(styles.input, {
                [formStyles.inputError]: errors?.heightInMeters,
              })}
            />
          </div>
        </div>
      )}
      {unitSystem === UnitSystem.METRIC && (
        <div className={styles.heightInputs}>
          <div className={styles.inputContainer}>
            <label className={styles.label} htmlFor='heightMeters'>
              m
            </label>
            <input
              id='heightMeters'
              type='number'
              value={m}
              min={0}
              max={2}
              onChange={e => {
                e.persist()
                setFieldValue('m', e.target.value)
                const heightInMeters = getHeightFromMetric(Number(e.target.value), Number(cm))
                const { ft, inches } = initializeHeightValues(heightInMeters)
                setFieldValue('heightInMeters', heightInMeters)
                setFieldValue('ft', ft)
                setFieldValue('inches', inches)
              }}
              className={classNames(styles.input, {
                [formStyles.inputError]: errors?.heightInMeters,
              })}
            />
          </div>
          <div className={styles.inputContainer}>
            <label className={styles.label} htmlFor='heightCentimeters'>
              cm
            </label>
            <input
              id='heightCentimeters'
              type='number'
              value={cm}
              min={0}
              max={99}
              onChange={e => {
                e.persist()
                setFieldValue('cm', e.target.value)
                const heightInMeters = getHeightFromMetric(Number(m), Number(e.target.value))
                const { ft, inches } = initializeHeightValues(heightInMeters)
                setFieldValue('heightInMeters', heightInMeters)
                setFieldValue('ft', ft)
                setFieldValue('inches', inches)
              }}
              className={classNames(styles.input, {
                [formStyles.inputError]: errors?.heightInMeters,
              })}
            />
          </div>
        </div>
      )}
      <ErrorMessage name={'heightInMeters'} component='div' className={formStyles.errorMessage} />
    </>
  )
}

export default HeightUnitInputs
